import { IClientPropalPeriodeModel } from "@common-models/*"
import React, { useState } from "react"
import { toAbsoluteUrl } from "@common-metronic/helpers"
import MyModal from "@common-utils/MyModal"
import PtfPeriodeAjoutVersionDocumentForm from "../actions/_PtfPeriodeAjoutVersionDocumentForm"
import GlobalHelper from "@common-helpers/GlobalHelper"
import { usePtfDetailsPeriodesBonsCommandeBonsLivraisonContext } from "./_PtfDetailsPeriodesBonsCommandeBonsLivraison"
import { useQueryClient } from "react-query"
import { IGetPeriodesBonsCommandeBonsLivraisonResponseModel } from "../core/_models"
import MyGoogleDriveFileViewerInModal from "../../../../components/MyDocumentViewer/MyGoogleDriveFileViewerInModal"

const PtfDetailsPeriodesBonsCommandeBonsLivraison_VersionsPtf = ({ periode }: IPtfDetailsPeriodesBonsCommandeBonsLivraison_VersionsPtfPropsModel) => {
     const context = usePtfDetailsPeriodesBonsCommandeBonsLivraisonContext()
     const queryClient = useQueryClient()

     const [currentVersionInModal, setCurrentVersionInModal] = useState<{
          reference: string
          googleDriveID: string
          googleMimeType: string
          loading: boolean
          mode: "edit" | "view"
     }>()

     const [addVersionDocumentPtf, setAddVersionDocumentPtf] = useState<{
          periode: IClientPropalPeriodeModel
          modalTitle: JSX.Element
          isModalFullScreen?: true
     }>()

     function currentVersionRef() {
          return periode.reference + GlobalHelper.incrementChar("a", periode.clientPropalPeriodeSuivis?.length || 0, "upper")
     }

     function nextVersionRef() {
          return periode.reference + GlobalHelper.incrementChar("a", (periode.clientPropalPeriodeSuivis?.length || 0) + 1, "upper")
     }

     function handleSubmitAddVersionDocumentCallback(val: IClientPropalPeriodeModel) {
          setAddVersionDocumentPtf(prev =>
               prev
                    ? {
                           ...prev,
                           isModalFullScreen: true,
                           modalTitle: (
                                <div className={"d-flex"}>
                                     <div>Édition de la {nextVersionRef()}</div>
                                     <button className={"btn btn-sm btn-success p-0 px-2 py-1 d-flex align-items-center ms-2"} onClick={() => setAddVersionDocumentPtf(undefined)}>
                                          Terminer <i className={"fas fa-check-cirle ms-1"} />
                                     </button>
                                </div>
                           ),
                      }
                    : undefined
          )
          queryClient.setQueryData<IGetPeriodesBonsCommandeBonsLivraisonResponseModel | undefined>(
               context.REACT_QUERY_KEY_GET_PERIODES_BC_BL,
               (prev: IGetPeriodesBonsCommandeBonsLivraisonResponseModel | undefined) => {
                    if (prev?.data) {
                         const currentVersionRefBeforeAdd = currentVersionRef()

                         prev.data.map((item, index) => {
                              item.clientPropalPeriodes?.map((item_, index_) => {
                                   if (item_.id === periode.id) {
                                        item_.clientPropalPeriodeSuivis = [
                                             {
                                                  googleDriveOldFileID: item_.googleDriveId,
                                                  oldReference: currentVersionRefBeforeAdd,
                                             },
                                             ...(item_.clientPropalPeriodeSuivis || []),
                                        ]
                                        item_["googleDriveId"] = val.googleDriveId
                                        return item_
                                   }
                              })
                         })
                         return prev
                    }
                    return prev
               }
          )
     }

     return (
          <div className="d-flex flex-column mb-5">
               <div className="d-flex align-items-center justify-content-between mb-3">
                    <div className="d-flex align-items-center">
                         <span className="text-gray-500 fs-7 fw-bold me-2 text-uppercase">Historique des versions</span>
                         <div className="h-1px w-50px bg-gray-200"></div>
                    </div>
                    <button
                         className="btn btn-sm btn-light-success btn-active-success py-1 px-3 fs-8 fw-bolder"
                         onClick={() =>
                              setAddVersionDocumentPtf({
                                   periode: periode,
                                   modalTitle: (
                                        <span>
                                             {currentVersionRef()} {"-->"} {nextVersionRef()}
                                        </span>
                                   ),
                              })
                         }
                    >
                         <i className="fas fa-plus fs-8 me-1" /> Nouvelle Version
                    </button>
               </div>

               <div className="d-flex flex-row overflow-auto gap-3 pb-2">
                    {/* Current Version - Highlighted */}
                    <div
                         className="d-flex align-items-center bg-light-success rounded border border-success border-dashed p-2 px-3 cursor-pointer min-w-150px"
                         onClick={() =>
                              setCurrentVersionInModal({
                                   googleDriveID: periode.googleDriveId as string,
                                   googleMimeType: periode.googleDriveMimeType as string,
                                   loading: true,
                                   reference: currentVersionRef(),
                                   mode: "view",
                              })
                         }
                    >
                         <div className="symbol symbol-30px me-2">
                              <img src={toAbsoluteUrl("/media/svg/files/doc.svg")} alt="doc" />
                         </div>
                         <div className="d-flex flex-column">
                              <span className="fs-7 fw-bolder text-gray-800">{currentVersionRef()}</span>
                              <span className="fs-9 fw-bold text-success">Actuelle</span>
                         </div>
                    </div>

                    {/* Past Versions - Muted */}
                    {periode.clientPropalPeriodeSuivis?.map((periodeSuivi, index) => (
                         <div
                              className="d-flex align-items-center bg-light rounded border border-gray-300 border-dashed p-2 px-3 cursor-pointer min-w-150px opacity-75 hover-opacity-100"
                              key={index}
                              onClick={() =>
                                   setCurrentVersionInModal({
                                        googleDriveID: periodeSuivi.googleDriveOldFileID as string,
                                        googleMimeType: periodeSuivi.googleDriveOldFileMimeType as string,
                                        loading: true,
                                        reference: `${periodeSuivi.oldReference}`,
                                        mode: "view",
                                   })
                              }
                         >
                              <div className="symbol symbol-30px me-2">
                                   <img src={toAbsoluteUrl("/media/svg/files/doc.svg")} className="grayscale-icon opacity-50" alt="doc" />
                              </div>
                              <div className="d-flex flex-column">
                                   <span className="fs-7 fw-bolder text-gray-600">{periodeSuivi.oldReference}</span>
                                   <span className="fs-9 text-muted">Archivée</span>
                              </div>
                         </div>
                    ))}
               </div>

               {/* Modals */}
               {addVersionDocumentPtf && (
                    <MyModal
                         title={addVersionDocumentPtf.modalTitle}
                         show={true}
                         onCloseCallback={() => setAddVersionDocumentPtf(undefined)}
                         size={"lg"}
                         fullscreen={addVersionDocumentPtf.isModalFullScreen}
                         noPadding={addVersionDocumentPtf.isModalFullScreen}
                    >
                         <PtfPeriodeAjoutVersionDocumentForm
                              ptf_periode_ID={addVersionDocumentPtf.periode!.id as number}
                              handleSubmitCallback={handleSubmitAddVersionDocumentCallback}
                              nextReference={`${nextVersionRef()}`}
                              currentVersionRef={`${currentVersionRef()}`}
                         />
                    </MyModal>
               )}

               {currentVersionInModal && (
                    <MyGoogleDriveFileViewerInModal
                         googleDriveID={currentVersionInModal.googleDriveID}
                         googleDriveMimetype={currentVersionInModal.googleMimeType as string}
                         modalTitle={<>{currentVersionInModal.reference}</>}
                         handleCloseModal={() => setCurrentVersionInModal(undefined)}
                         modalFullScreen
                    />
               )}
          </div>
     )
}

interface IPtfDetailsPeriodesBonsCommandeBonsLivraison_VersionsPtfPropsModel {
     periode: IClientPropalPeriodeModel
}

export default PtfDetailsPeriodesBonsCommandeBonsLivraison_VersionsPtf
